export default __webpack_public_path__ + "images/0x34a528da3b2ea5c6ad1796eba756445d1299a577.png";